import { render } from "./TestimonialsSection.vue?vue&type=template&id=5b863b5d&scoped=true"
import script from "./TestimonialsSection.vue?vue&type=script&lang=js"
export * from "./TestimonialsSection.vue?vue&type=script&lang=js"

import "./TestimonialsSection.vue?vue&type=style&index=0&id=5b863b5d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b863b5d"]])

export default __exports__